import { twApi } from '../api';
import { TenantDriverSettings } from './tenantDriverSettings.model';

export const tenantDriverSettingsApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getTenantDriverSettings: builder.query<{data: TenantDriverSettings}, void>({
      query: () => '/tenant/driver-settings',
      providesTags: [{ type: 'TenantDriverSettings', id: 'TENANT_DRIVER_SETTINGS' }]
    }),
    updateTenantDriverSettings: builder.mutation<
      { message: string; content: TenantDriverSettings },
      Omit<TenantDriverSettings, 'id'>
    >({
      query: (settings) => ({
        url: '/tenant/driver-settings',
        method: 'PATCH',
        body: settings
      }),
      transformResponse: (response: any) => {
        return {
          message: response.message,
          content: response.data
        };
      },
      invalidatesTags: [{ type: 'TenantDriverSettings', id: 'TENANT_DRIVER_SETTINGS' }]
    })
  })
});

export const { useGetTenantDriverSettingsQuery, useUpdateTenantDriverSettingsMutation } =
  tenantDriverSettingsApi;
